import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import AllProducts from "./components/AllProducts/AllProducts.jsx";
import Checkout from "./components/Checkout/index.jsx";
import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import OrderDetail from "./components/Orders/OrderDetail";
import OrderData from "./components/Orders/OrderTable";
import ProductSingle from "./components/ProductSingle/ProductSingle";
import OrderRoute from "./components/ProtectedRoute/OrderRoute.jsx";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";
import SingleProduct from "./components/SingleProduct/SingleProduct";
import User from "./components/User";
import Login from "./components/User/Login";
import LoginWithGoogle from "./components/User/LoginWithGoogle";
import Signup from "./components/User/Signup";
import Wishlist from "./components/Wishlist/Wishlist";
import Aboutus from "./pages/Aboutus";
import Cancel from "./pages/Cancel";
import Coutomer from "./pages/Coutomer.jsx";
import Failed from "./pages/Failed";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import ShippingPolicy from "./pages/ShippingPolicy";
import Succes from "./pages/Succes";
import TermsAndConditions from "./pages/TermsAndConditions";
import NotificationProvider from "./utils/SalesNotification/NotificationProvider.jsx";
import Support from "./pages/Support";
import Description from "./components/support/Description.jsx";
import AppContext from "./utils/context";
import Disclaimer from "./pages/Disclaimer.jsx";
import FAQs from "./pages/FAQs.jsx";

function App() {

  return (
    <BrowserRouter>
      <AppContext>
        <div className=" sticky top-0 z-50 ">
          <Header />
        </div>

        <Routes>
          <Route path="/" element={<NotificationProvider />}>
            <Route index element={<Home />} />
            <Route path="/product/:id" element={<SingleProduct />} />
            <Route path="/single-product/:id" element={<ProductSingle />} />
            {/* <Route path="/category/:slug" element={<Category />} /> */}
            <Route path="/category/:slug" element={<AllProducts />} />
          </Route>

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <User />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <OrderData />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                <OrderDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route
            path="/sucess"
            element={
              <OrderRoute>
                <Succes />
              </OrderRoute>
            }
          />
          <Route path="/cancel" element={<Failed />} />
          <Route path="/customer-policy" element={<Coutomer />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/faqs" element={<FAQs />} />
          <Route path="/cancellation-policy" element={<Cancel />} />
          <Route path="/shippingPolicy" element={<ShippingPolicy />} />
          <Route path="/TermsAndConditions" element={<TermsAndConditions />} />
          <Route path="/aboutus" element={<Aboutus />} />
          <Route path="/google" element={<LoginWithGoogle />} />
          <Route path="/support" element={<Support />} />
          <Route path="/support/:ticketID" element={<Description />} />
        </Routes>

        <Footer />
      </AppContext>
    </BrowserRouter>
  );
}

export default App;
